import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import ENV from '@root/src/javascripts/getEnv'

if (ENV.sentry) {
  const options = {
    release: __COMMIT_HASH__, // eslint-disable-line no-undef
    tags: {
      environment: ENV.name,
      language: 'javascript',
      application: 'frontend',
    },
    shouldSendCallback (data) {
      if (!ENV.sentry.active) {
        console.error(data)
      }
      return ENV.sentry.active
    },
    dataCallback: (data) => {
      const newData = data
      if (!data.hasOwnProperty('extra')) { // eslint-disable-line no-prototype-builtins
        newData.extra = {}
      }

      newData.extra.store = window.__store.state // eslint-disable-line no-underscore-dangle

      return newData
    },
  }

  Raven
    .config(ENV.sentry.dsn, options)
    .addPlugin(RavenVue, Vue)
    .install()
}

export const log = function(error, data, loglevel) { // eslint-disable-line import/prefer-default-export, max-len, func-names
  if (!ENV.sentry.active) {
    console.error(error)
    console.error(data)
  }

  const e = new Error(error)
  const context = {}
  if (data) {
    context.data = data
  }

  Raven.captureException(e, {
    extra: context,
    tags: { loglevel: loglevel || 'normal' },
  })
}
